import { Component, OnDestroy, OnInit } from '@angular/core';
import { APIService } from '../../../api/api.service';
import { NotifierService } from '../../../_services/notifier.service';

@Component({
  //moduleId: module.id.toString(),
  templateUrl: './manage.policies.component.html',
})
export class PoliciesComponenet implements OnInit, OnDestroy {
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  policies: any = [];
  updatePolicy: any;
  policyAction: string;

  accountId = localStorage.getItem('accountId');
  regionId = localStorage.getItem('regionId');
  currentMessage: any;
  headers: any = [
    {
      id: 'policyName',
      name: 'Policy Name',
    },
    {
      id: 'menuList',
      name: 'Menu List',
      alter: (param: any) => {
        return param.menuList.join(', ');
      },
    },
    { id: 'accessType', name: 'Access Type' },
  ];

  constructor(
    private apiServer: APIService,
    private notifier: NotifierService
  ) {}
  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);

      if (d.value == null) {
        return;
      }

      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }

  async load() {
    this.notifier.loading(true);
    let data = { clientID: this.userId, action: 'fetchAll' };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    //https://api.swayam.cloud/v3/admin/support
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/policydetails`;

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    console.log(result);

    if (result.status == '1' || result.s == '1') {
      this.policies = result.policyDetails;
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }

    this.notifier.loading(false);
  }

  updatePolicyAction(group: any) {
    this.policyAction = 'update';
    this.updatePolicy = group;
  }

  async hideUpdatePolicy(event: any) {
    if (event) {
      this.updatePolicy = event;
      await this.load();
    }
    this.updatePolicy = null;
  }

  createPolicy() {
    this.policyAction = 'add';
    this.updatePolicy = {
      policyName: '',
      menuList: [],
      accessType: 'readOnly',
    };
  }

  callFunction(name: any, param: any) {
    return;
  }
}
